// extracted by mini-css-extract-plugin
module.exports = {"fixSize":"styles-module__fixSize___a39HH","cardError":"styles-module__cardError___QH-Y-"};